module.exports = __webpack_public_path__ + "static/media/IMG_20191025_082402_287 - Emma Xie.0a27a91e.jpg";